export default __webpack_public_path__ + "fonts/216ae7c00d4b0399035ec0bcaa275583.svg";